import './App.css';
import { useState, useEffect, useRef } from 'react';
import { FaWhatsapp } from "react-icons/fa";

const AudioPlayer = ({ src, itemPlay }) => {

    const [currentTime, setCurrentTime] = useState(0); // Tempo atual do áudio


    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    const [audiocarregado, setAudiocarregado] = useState(false);
    const [currentAudio, setCurrentAudio] = useState(null); // Mantém o áudio selecionado
    
    const audioRef = useRef(null); // Referência para o elemento <audio>


    

const [isPlaying, setIsPlaying] = useState(audiocarregado);
        
        const [duration, setDuration] = useState(0); // Duração total do áudio
        
        const [progress, setProgress] = useState(0);
        const [volume, setVolume] = useState(1);
        // const audioRef = useRef(null);


        useEffect(() => {
            const audio = audioRef.current;
            if (audio) {
              audio.currentTime = currentTime; // Retorna para o tempo salvo
              audio.play();
            }
          }, []); // Executa apenas na montagem do componente
        

        const handleTimeUpdate = () => {
            setCurrentTime(audioRef.current.currentTime);
            if (audioRef.current) {
                // const currentTime = audioRef.current.currentTime;
                // const duration = audioRef.current.duration;
                setProgress((currentTime / duration) * 100);
            }
        };

        const handleLoadedMetadata = () => {
            if (audioRef.current) {
                setDuration(audioRef.current.duration); // Obtém a duração total do áudio
            }
        };

        // const [duration, setDuration] = useState(0);

        const audioContextRef = useRef(null); // Referência para o AudioContext
        const sourceNodeRef = useRef(null); // Referência para o MediaElementSourceNode
        const gainNodeRef = useRef(null); // Referência para o GainNode


        const handlePlayPause = () => {

            if (audioRef.current.paused) {
                audioRef.current.play();
            } else {
                audioRef.current.pause();
            }
        };
        
        const handleSeek = (event) => {

            const seekTo = parseFloat(event.target.value);
            console.log((event.target.value / 100) * audioRef.current.duration);
            setProgress(seekTo);
            if (audioRef.current) {
                audioRef.current.currentTime = (event.target.value / 100) * audioRef.current.duration;
                // audioRef.current.seek(seekTo);
            }
            // const seekTime = (event.target.value / 100) * audioRef.current.duration;
            // audioRef.current.currentTime = seekTime;
            // setProgress(event.target.value);
        };

        const handleVolumeChange = (event) => {
            const newVolume = event.target.value;
            setVolume(newVolume);
            audioRef.current.volume = newVolume;
        };

        const handleStop = () => {
            setIsPlaying(false);
            if (audioRef.current) {
                audioRef.current.pause();
                audioRef.current.currentTime = 0; // Reinicia o áudio
            }
        };


        const setupEqualizer = (audioContext, source) => {
            const frequencies = [60, 170, 350, 1000, 3500, 10000]; // Graves a agudos
            const filters = frequencies.map((freq) => {
                const filter = audioContext.createBiquadFilter();
                filter.type = "peaking"; // Tipo de filtro para equalização
                filter.frequency.value = freq; // Freqüência central
                filter.Q.value = 1; // Controle da largura da banda
                filter.gain.value = 0; // Ganho inicial
                return filter;
            });

            // Conectar os filtros em série
            filters.reduce((prev, curr) => {
                prev.connect(curr);
                return curr;
            });

            // Conectar a saída do último filtro
            filters[filters.length - 1].connect(audioContext.destination);

            // Conectar o source ao primeiro filtro
            source.connect(filters[0]);

            return filters; // Retorna os filtros para controle
        };        

        const setupNoiseReduction = (audioContext, source) => {
            const highPass = audioContext.createBiquadFilter();
            highPass.type = "highpass";
            highPass.frequency.value = 10; // Remove sons abaixo de 100 Hz (ruído grave)

            const lowPass = audioContext.createBiquadFilter();
            lowPass.type = "lowpass";
            lowPass.frequency.value = 15000; // Remove sons acima de 15 kHz (ruído agudo)

            // Conectar os filtros em cadeia
            source.connect(highPass).connect(lowPass).connect(audioContext.destination);
        };

        const setupCompressor = (audioContext, source) => {
            const compressor = audioContext.createDynamicsCompressor();
            compressor.threshold.value = -30; // Nível de ativação (dB)
            compressor.knee.value = 40; // Curvatura da compressão
            compressor.ratio.value = 12; // Taxa de compressão
            compressor.attack.value = 0.01; // Tempo para começar a comprimir
            compressor.release.value = 0.25; // Tempo para parar de comprimir

            // Conectar o compressor
            source.connect(compressor).connect(audioContext.destination);
        };

        const setupReverb = async (audioContext, source) => {
            const convolver = audioContext.createConvolver();
            const response = await fetch("/reverb-impulse-response.wav"); // Arquivo de resposta de impulso
            const arrayBuffer = await response.arrayBuffer();

            // Decodifica o arquivo de resposta de impulso
            const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

            // Define o buffer no ConvolverNode
            convolver.buffer = audioBuffer;

            source.connect(convolver).connect(audioContext.destination);
        };

        const setupPanning = (audioContext, source) => {
            const panner = audioContext.createStereoPanner();
            panner.pan.value = 0; // -1 para esquerda, 1 para direita, 0 para centro

            source.connect(panner).connect(audioContext.destination);
        };

        const handleSkip = (seconds) => {
            const newTime = Math.min(
              Math.max(audioRef.current.currentTime + seconds, 0),
              duration
            );
            audioRef.current.currentTime = newTime;
            setProgress(newTime);
          };

        useEffect(() => {
            
            if (audioRef.current) {

                console.log('teste erro audio');

                

                // Criar o AudioContext apenas uma vez
                if (!audioContextRef.current) {
                    // audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
                    audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)({
                        sampleRate: 96000, // Reamostra o áudio para 48 kHz
                    });
                }                

                // Criar o MediaElementSourceNode apenas uma vez
                if (!sourceNodeRef.current) {
                    // Conectar o <audio> ao AudioContext
                    // sourceNodeRef.current = audioContextRef.current.createMediaElementSource(audioRef.current);

                    const sourceNode = audioContextRef.current.createMediaElementSource(audioRef.current);

                    // Criar o GainNode para controle de volume
                    gainNodeRef.current = audioContextRef.current.createGain();

                    const analyser = audioContextRef.current.createAnalyser();
                    const gainNode = audioContextRef.current.createGain();

                    // Conectar os nós: MediaElementSourceNode -> GainNode -> Destination
                    // sourceNodeRef.current.connect(gainNodeRef.current).connect(audioContextRef.current.destination);

                    sourceNode.connect(analyser); // Conectar ao analisador
                    analyser.connect(gainNode).connect(audioContextRef.current.destination); // Saída final

                    sourceNodeRef.current = { sourceNode, analyser, gainNode };

                    // Analisar o volume
                    const dataArray = new Uint8Array(analyser.frequencyBinCount);
                    analyser.getByteFrequencyData(dataArray);

                    // Calcular o volume médio
                    const averageVolume = dataArray.reduce((sum, value) => sum + value, 0) / dataArray.length || 1; // Evitar NaN

                    // Ajustar o ganho (volume desejado)
                    const targetVolume = 5; // Meta de volume
                    gainNode.gain.value = targetVolume / averageVolume;

                    // setupEqualizer(audioContextRef.current, sourceNode);
                    // No seu código principal:
                    const filters = setupEqualizer(audioContextRef.current, sourceNodeRef.current.sourceNode);
                    // Ajustar as frequências dinamicamente:
                    filters[0].gain.value = 20; // Aumentar os graves, por exemplo

                    setupNoiseReduction(audioContextRef.current, sourceNodeRef.current.sourceNode);

                    setupCompressor(audioContextRef.current, sourceNodeRef.current.sourceNode);

                    // setupReverb(audioContextRef.current, sourceNodeRef.current.sourceNode);

                    setupPanning(audioContextRef.current, sourceNodeRef.current.sourceNode);                       

                    // Configurar o volume inicial
                    //gainNodeRef.current.gain.value = 20; // Volume padrão (1 = 100%)
                }
            }
            //};

            // normalizeVolume();
        }, [currentAudio]);


        const audioSrc = "path-to-your-audio-file.mp3"; // Substitua pelo caminho do seu arquivo de áudio
        const url = "https://podcast.tibmacae.org.br/?id="

        const handleShareToWhatsApp = () => {
            const message = encodeURIComponent(
                `Confira a esta pregação abençoada: \n\n*_${itemPlay.tema}_*\n\`\`\`${itemPlay.pastor}\`\`\`\n\n${url}${itemPlay.id}`
            );
            const whatsappUrl = `https://wa.me/?text=${message}`;
            window.open(whatsappUrl, "_blank"); // Abre o link do WhatsApp em uma nova aba
        };

//   const audioRef = useRef(null);
//   const [currentTime, setCurrentTime] = useState(0);

//   useEffect(() => {
//     const audio = audioRef.current;
//     if (audio) {
//       audio.currentTime = currentTime; // Retorna para o tempo salvo
//       audio.play();
//     }
//   }, []); // Executa apenas na montagem do componente

//   const handleTimeUpdate = () => {
//     setCurrentTime(audioRef.current.currentTime);
//   };

const togglePlay = () => {
    const audio = audioRef.current;
    if (audio) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play().catch((error) => {
          console.error("Erro ao tentar reproduzir o áudio:", error);
        });
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (

    <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    maxWidth: "100%",
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: "0 auto",
                    textAlign: "center"
                }}>
    
    
    
                    <p className='title_audio_executando'><b>Tema:</b> {itemPlay.tema}</p>
    
                    <div className='buttoncontrols'>
                        {/* <button className='audiobutton' onClick={handlePrev}>⏮️</button> */}
                        <button className='audiobutton' onClick={() => handleSkip(-5)}>⏪ 5s</button>
                        <button className='audiobutton' onClick={togglePlay}>
                            {isPlaying ? "⏸️ Pausar" : "▶️ Tocar"}
                        </button>
                        <button className='audiobutton' onClick={handleStop}>⏹️ Parar</button>
                        {/* <button className='audiobutton' onClick={handleNext}>⏭️</button> */}
                        <button className='audiobutton' onClick={() => handleSkip(5)}>⏩ 5s</button>
                        
                    </div>
    
                    {windowSize.width > 480 ? 
                    <div className='audio-container'>
                        <audio
                            controls
                            ref={audioRef}
                            src={src}
                            autoPlay
                            onLoad={() => setDuration(audioRef.current.duration())}
    
                            onLoadedMetadata={handleLoadedMetadata} // Obtém a duração do áudio
                            // controls
                            onTimeUpdate={handleTimeUpdate}
                        />
                        {/* <div style={{ marginTop: "10px", display: "flex", justifyContent: "center", gap: "10px" }}> */}
    
                        {/* Botão de compartilhar no WhatsApp */}
                        <button
                            onClick={handleShareToWhatsApp}
                            style={{
                                backgroundColor: "#25D366",
                                color: "white",
                                border: "none",
                                borderRadius: "50px",
                                padding: "10px 15px",
                                fontSize: "16px",
                                cursor: "pointer",
                                display: "flex",                            
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            <FaWhatsapp size={20} />
    
                        </button>
                        {/* </div> */}
                    </div>
    
                    :
                    <div className='audio-container-menor'>
                        <audio
                            controls
                            ref={audioRef}
                            src={src}
                            autoPlay
                            onLoad={() => setDuration(audioRef.current.duration())}
    
                            onLoadedMetadata={handleLoadedMetadata} // Obtém a duração do áudio
                            // controls
                            onTimeUpdate={handleTimeUpdate}
                        />
                        <div className='div-compartilhar-menor'>
                            <p>Compartilhar</p>
                        <button
                            onClick={handleShareToWhatsApp}
                            style={{
                                backgroundColor: "#25D366",
                                color: "white",
                                border: "none",
                                borderRadius: "50px",
                                padding: "10px 15px",
                                fontSize: "16px",
                                cursor: "pointer",
                                display: "flex",                            
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            <FaWhatsapp size={20} />
    
                        </button>
                        </div>                  
                    </div>                                    
                    
                    }                               
    
                </div>

    // <audio
    //   ref={audioRef}
    //   src={src} // O áudio vem como propriedade (src)
    //   controls
    //   onTimeUpdate={handleTimeUpdate} // Salva o tempo de reprodução
    // />
  );
};

export default AudioPlayer;